(function () {
    'use strict';

    angular
        .module('aricControllers')
        .controller('AricOwnerCertificationController', Controller);

    Controller.$inject = ['$state', 'aricControls']

    function Controller($state, aricControls) {
        if (!$state.is('aricCertification.user')) return;

        if (!aricControls.length) {
            $state.go('aricCertification.user.completed', {}, { location: 'replace' });
            return;
        }

        var needsWelcome;
        var isReadyForSubmit;

        // Go To Welcome
        needsWelcome = _.every(aricControls, { ControlAssessment: { IsReadyForCertification: true } })
        if (needsWelcome) {
            $state.go('aricCertification.user.welcome', {}, { location: 'replace' });
            return;
        }

        // Go To First ReadyForCertification Control
        var aricControlIdx = _.findIndex(aricControls, { ControlAssessment: { IsReadyForCertification: true } });
        if (aricControlIdx > -1) {
            $state.go('aricCertification.user.control', { ControlID: aricControls[aricControlIdx].ControlID }, { location: 'replace' });
            return;
        }

        isReadyForSubmit = _.every(aricControls, { ControlAssessment: { IsCertificationInProgress: true } });

        // Go To Last Control
        if (isReadyForSubmit) {
            $state.go('aricCertification.user.control', { ControlID: aricControls[aricControls.length - 1].ControlID }, { location: 'replace' });
        }
    }
})();